import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import ButtonGeneral from '../buttons/buttonGeneral';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { types } from '../../../../redux/types';

type Props = {
    stepsLength: number;
    onClick?: any;
    subTitle?: string;
};

const StepperReset = ({ stepsLength, onClick, subTitle }: Props) => {
    const dispatch: any = useDispatch();
    const { activeStep } = useSelector((state: RootState) => state.general);

    return (
        <>
            {stepsLength > 0 && activeStep === stepsLength && (
                <Paper square elevation={0} sx={{ p: 3 }}>
                    <Typography sx={{ mt: 4 }} align="center">
                        Todos los pasos completados - Se ha guardado
                        exitosamente la información
                    </Typography>
                    {subTitle && (
                        <Typography sx={{ mt: 4 }} align="center">
                            {subTitle}
                        </Typography>
                    )}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            pt: 2,
                            mt: 1,
                        }}
                    >
                        <Box sx={{ flex: '1 1 auto' }} />
                        <ButtonGeneral
                            onClick={
                                onClick
                                    ? onClick
                                    : () =>
                                        dispatch({ type: types.resetStepper })
                            }
                            startIcon={<RestartAltIcon color="secondary" />}
                            title="Reiniciar"
                        />
                    </Box>
                </Paper>
            )}
        </>
    );
};

export default StepperReset;
